import { StatusCommande } from '@/enum/StatusCommande'
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloCmdRow, cleanAloCmdRow } from './AloCmdRow'


export interface AloCommande extends AloBase {          
    famId:number    
    cmdStatus:number|null
    cmdTotal:number|null
    cmdDatadd:string    
    cmdDatpaiement:string
    cmdDatvalidation:string    
    rows:Array<AloCmdRow>    
    clientSecret:string
}

export const getDefaultAloCommande = ():AloCommande => {
    return {  
        ...getDefaultAloBase(),        
        famId:0,
        cmdStatus:StatusCommande.bcd,
        cmdTotal:null,
        cmdDatadd:'',
        cmdDatpaiement:'',
        cmdDatvalidation:'',
        rows:[],
        clientSecret:''
    }
}

export const cleanAloCommande = (commande:AloCommande) => {
    if(!commande) return    
    if(!commande.id) delete commande.id
    if(!commande.famId) delete commande.famId
    commande.rows.forEach(r => cleanAloCmdRow(r))
    
}